import { useNavigate } from "react-router-dom";
import { Popup, Space, Button } from "antd-mobile";
import "./index.css";
import { useTranslation } from "react-i18next";
import { getText } from "../../../../utils/util";
import { useState } from "react";
import Search from "../../../../components/search";
import { imageConfig } from "../../../../config/config";

export default function CoinPopup({
  isShowCoin,
  setIsShowCoin,
  coinListData,
  index,
  ctmarketlist,
  collectlist,
}) {
  const navigate = useNavigate();
  const { t: translate } = useTranslation();
  const [popIndex, setPopIndex] = useState(index);
  const [name, setName] = useState("");
  const toPage = (name) => {
    const uri = "trade";
    navigate(`/${uri}/${name}`);
    setIsShowCoin(false);
  };

  //去重
  function uniqueBySet(arr, key) {
    const uniqueSet = new Set();
    const uniqueArray = [];
    for (const item of arr) {
      const keyValue = item[key];
      if (!uniqueSet.has(keyValue)) {
        uniqueArray.push(item);
        uniqueSet.add(keyValue);
      }
    }
    return uniqueArray;
  }
  const getNodes = () => {
    const nodes = [];
    let coinListDataTemp = coinListData;
    
    for (const key in coinListDataTemp) {
      if (name) {
        if (name.toLowerCase() !== key) {
          continue;
        }
      }
      const findCoinData = ctmarketlist.find(v => v.coinname === key)
      const showName = findCoinData?.type === 2 ? findCoinData?.issueName?.toUpperCase() : key?.toUpperCase()

      nodes.push(
        <li
          className="coinPopupTopTitle-30"
          onClick={() => {
            toPage(key);
          }}
        >
          <div className="coinPopupTopTitle-31">
            <div className="coinPopupTopTitle-32">
              <span className="coinPopupTopTitle-33">
                {showName.toUpperCase()}
                <small className="coinPopupTopTitle-34">/USDT</small>
              </span>
            </div>
          </div>
          <div className="coinPopupTopTitle-35">
            <span
              className={
                coinListData[key]?.close > coinListData[key]?.open
                  ? "coinPopupTopTitle-36"
                  : "coinPopupTopTitle-78"
              }
            >
              {coinListData[key]?.close}
            </span>
          </div>
        </li>
      );
    }
    return nodes;
  };

  const getNodes1 = () => {
    const nodes = [];
    collectlist = uniqueBySet(collectlist, "coinname");
    for (const collect of collectlist) {
      if (name) {
        if (name.toLowerCase() !== collect.coinname) {
          continue;
        }
      }
      nodes.push(
        <li
          className="coinPopupTopTitle-30"
          onClick={() => {
            toPage(collect.coinname);
          }}
        >
          <div className="coinPopupTopTitle-31">
            <div className="coinPopupTopTitle-32">
              <span className="coinPopupTopTitle-33">
                {collect.coinname?.toUpperCase()}
                <small className="coinPopupTopTitle-34">/USDT</small>
              </span>
            </div>
          </div>
          <div className="coinPopupTopTitle-35">
            <span
              className={
                coinListData[collect.coinname]?.close >
                coinListData[collect.coinname]?.open
                  ? "coinPopupTopTitle-36"
                  : "coinPopupTopTitle-78"
              }
            >
              {coinListData[collect.coinname]?.close}
            </span>
          </div>
        </li>
      );
    }
    return nodes;
  };

  const getLogo = (name) => {
    let logo = "";
    for (const ctmarket of ctmarketlist) {
      if (name == ctmarket.coinname) {
        logo = imageConfig.baseImageUrl + ctmarket.logo;
        break;
      }
    }
    return logo;
  };
  return (
    <Popup
      visible={isShowCoin}
      onMaskClick={() => {
        setIsShowCoin(false);
      }}
      position="left"
      bodyStyle={{ backgroundColor: "#f5f5f5" }}
    >
      <div className="coinPopupTopTitle-1">
        <div className="coinPopupTopTitle-2">
          <p className="coinPopupTopTitle-3">{translate(getText("貨幣行情"))}</p>
        </div>
        <div className="coinPopupTopTitle-4">
          <ul className="coinPopupTopTitle-5">
            <li
              className={
                popIndex == 1 ? "coinPopupTopTitle-7" : "coinPopupTopTitle-6"
              }
              onClick={() => {
                setPopIndex(1);
              }}
            >
              {translate(getText("自選"))}
            </li>
            <li
              className={
                popIndex == 2 ? "coinPopupTopTitle-7" : "coinPopupTopTitle-6"
              }
              onClick={() => {
                setPopIndex(2);
              }}
            >
              USDT
            </li>
          </ul>
        </div>
        <div className="coinPopupTopTitle-8">
          <i className="coinPopupTopTitle-9"></i>
          <div className="coinPopupTopTitle-10">
            <div className="coinPopupTopTitle-11">
              <input
                placeholder={translate(getText("搜索幣種"))}
                // maxlength="140"
                step=""
                // enterkeyhint="done"
                // autocomplete="off"
                type=""
                className="coinPopupTopTitle-13"
                onChange={(e) => {
                  setName(e.target.value);
                }}
              />
            </div>
          </div>
        </div>
        <div className="coinPopupTopTitle-14">
          <div className="coinPopupTopTitle-15">
            <div className="coinPopupTopTitle-16">
              <div className="coinPopupTopTitle-17">
                <div className="coinPopupTopTitle-18">
                  <div className="coinPopupTopTitle-19">
                    <div className="coinPopupTopTitle-20">
                      <div className="coinPopupTopTitle-21">
                        <div className="coinPopupTopTitle-22">
                          <ul className="coinPopupTopTitle-23"></ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="coinPopupTopTitle-24">
                  <div className="coinPopupTopTitle-25">
                    <div className="coinPopupTopTitle-26">
                      <div className="coinPopupTopTitle-27">
                        <div className="coinPopupTopTitle-28">
                          <ul className="coinPopupTopTitle-29">
                            {popIndex == 2 && getNodes()}
                            {popIndex == 1 && getNodes1()}
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Popup>
  );
}
